// extracted by mini-css-extract-plugin
export var errorIcon = "_lt-1";
export var nameLogo = "_lt-0";